<template lang="pug">
  div
    v-btn(flat small icon color="app-edit" @click="openDialog" class="ma-0")
      v-icon edit

    v-dialog(lazy persistent v-model="dialog" max-width=440, scrollable)
      v-card(v-if="one !== null")
        v-card-title.app-edit
          span.white--text {{$t('edit')}}
          v-spacer
          v-btn.ma-0(flat small icon color="white" @click="dialog = false")
            v-icon(size=18) close

        v-card-text(style="max-height: 600px")
          v-text-field(
            type="text"
            :label="$t('code')"
            v-model="one.code"
            autocapitalize="off"
            ref="code"
            :rules="[rules.required]"
            validate-on-blur
            autofocus
            )

          v-text-field(
            type="text"
            :label="$t('name')"
            v-model="one.name"
            autocapitalize="off"
            ref="name"
            :rules="[rules.required]"
            validate-on-blur
            )

          v-layout(
            row
            wrap
            v-for="customer, cuIndex in one.customers"
            :key="cuIndex"
          )
            v-flex(xs10)
              v-text-field(
                type="text"
                :label="'担当者' + (cuIndex + 1)"
                v-model="customer.name"
                :ref="'customer_name_' + cuIndex"
                :rules="[rules.required]"
                autocapitalize="off"
                )

            v-flex(xs2)
              v-btn(
                icon
                small
                color="grey--text"
                @click="removePerson(cuIndex)"
                v-if="customer.id === null && cuIndex >= 1"
                )
                v-icon close

          v-btn(
            icon
            small
            raised
            color="primary"
            @click="appendPerson"
            )
            v-icon add

        v-card-actions
          v-spacer
          v-btn(
            flat
            color="app-edit"
            @click="save")
            span {{$t('save')}}
</template>

<script>
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      dialog: false,
      one: null
    }
  },
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  mixins: [rules],
  watch: {
    dialog (val) {
      if (!val) {
        this.one = null
      }
    }
  },
  methods: {
    openDialog () {
      this.one = JSON.parse(JSON.stringify(this.company))
      this.dialog = true
    },
    save () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.$ajax
        .patch(`/companies/index/${self.one.id}`, self.one)
        .then(function (response) {
          self.dialog = false
          self.$emit('complete', self.one.id, response.data.company)
        })
        .catch(function (error) {
          console.dir(error)
          self.$toastr.error(
            self.$t(error.response.data.translate_code) ||
              error.response.data.message
          )
        })
    },
    appendPerson () {
      let next = this.one.customers.length + 1
      this.one.customers.push({
        id: null,
        name: 'ご担当者' + next
      })
    },
    removePerson (index) {
      this.one.customers.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Customer/Edit.vue